import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipDirectiveModule, TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives';
import { CheckoutAboutFeesComponent } from './components/checkout-about-fees/checkout-about-fees.component';

import { CheckoutAutomaticComponent } from './components/checkout-automatic/checkout-automatic.component';
import { ChipsComponent } from './components/dialog-price-edittion/chips/chips.component';
import { DialogPriceEditionComponent } from './components/dialog-price-edittion/dialog-price-edition.component';
import { CheckoutWrapperComponent } from './wrapper/checkout-wrapper.component';

import { AsyncPipe } from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { TrCheckboxModule } from '@toro/common/shared/components/tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { TrPlannedCheckoutInputModule } from '@toro/common/shared/components/tr-planned-checkout-input/tr-planned-checkout-input.module';
import { TrStepInputModule } from '@toro/common/shared/components/tr-step-input/tr-step-input.module';
import { StockPipesModule } from '../../../pipes/stock-pipes.module';
import { CheckoutHeaderComponent } from './components/checkout-header/checkout-header.component';
import { CheckoutInvestmentComponent } from './components/checkout-investment/checkout-investment.component';
import { ContractsComponent } from './components/checkout-investment/contracts/contracts.component';
import { CheckoutManualComponent } from './components/checkout-manual/checkout-manual.component';
import { CheckoutResumeComponent } from './components/checkout-resume/checkout-resume.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';

import { FeatureFlagService } from '@toro/common/shared/services/feature-flag/feature-flag.service';
import { TrackingsService } from '../../../services/tracking.service';
import { CheckoutSuitabilityDisclaimerModule } from '../../components/checkout-suitability-disclaimer/checkout-suitability-disclaimer.module';
import { WithoutSuitabilityDisclaimerModule } from '../../components/without-suitability-disclaimer/without-suitability-disclaimer.module';
import { SantanderSuitabilityService } from '../../services/santander-suitability/santander-suitability.service';
import { SantanderGuaranteeIncreaseModalModule } from '@toro/common/shared/components/santander-guarantee-increase-modal/santander-guarantee-increase-modal.module';
import { SuccessAsidePanelModule } from "../success-aside-panel/success-aside-panel.module";
import { CheckoutErrorPanelComponent } from './components/checkout-error-panel/checkout-error-panel.component';
import { ExpiredProfilePanelComponent } from './components/expired-profile-panel/expired-profile-panel.component';
import { NoProfilePanelComponent } from './components/no-profile-panel/no-profile-panel.component';
import { NonCompliancePanelComponent } from './components/non-compliance-panel/non-compliance-panel.component';

@NgModule({
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    imports: [
        SvgIconModule,
        MatSlideToggleModule,
        CommonModule,
        TrPlannedCheckoutInputModule,
        StockPipesModule,
        FormsModule,
        ReactiveFormsModule,
        TrCheckboxModule,
        TrStepInputModule,
        SuccessAsidePanelModule,
        CheckoutSuitabilityDisclaimerModule,
        WithoutSuitabilityDisclaimerModule,
        TooltipDirectiveModule,
        TrSpinnerButtonDirectiveModule,
        SantanderGuaranteeIncreaseModalModule,
    ],
    declarations: [
        CheckoutWrapperComponent,
        CheckoutHeaderComponent,
        CheckoutInvestmentComponent,
        CheckoutManualComponent,
        CheckoutAutomaticComponent,
        CheckoutAboutFeesComponent,
        DialogPriceEditionComponent,
        ContractsComponent,
        CheckoutResumeComponent,
        ChipsComponent,
        SkeletonComponent,
        ExpiredProfilePanelComponent,
        NoProfilePanelComponent,
        CheckoutErrorPanelComponent,
        NonCompliancePanelComponent,
    ],
    exports: [],
    entryComponents: [
        CheckoutWrapperComponent,
        DialogPriceEditionComponent,
        CheckoutResumeComponent,
        CheckoutAboutFeesComponent,
        ExpiredProfilePanelComponent,
        NoProfilePanelComponent,
        CheckoutErrorPanelComponent,
        NonCompliancePanelComponent,
    ],
    providers: [
        AsyncPipe,
        FeatureFlagService,
        SantanderSuitabilityService,
        TrackingsService,
    ],
})
export class CheckoutPanelModule { }
